import type { IRoute } from '@umijs/max';
import { hasMenuAccess, hasPermission } from '@/utils/permission';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: UserAPI.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  return {
    isLoggedIn: !!currentUser?.pid,
    canAdmin: !!currentUser?.pid && currentUser.isSuperuser === true,
    routeFilter: (route: IRoute) => !!route.path && hasMenuAccess(currentUser, route.path),
    hasPermission: (code: string) => hasPermission(currentUser, code),
  };
}
